/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Page_Step_3Inputs */

const en_invite_page_step_3 = /** @type {(inputs: Invite_Page_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Their focus time adds to your progress`)
};

const ar_invite_page_step_3 = /** @type {(inputs: Invite_Page_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يُضاف وقت تركيزهم إلى تقدمك`)
};

const de_invite_page_step_3 = /** @type {(inputs: Invite_Page_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre Fokuszeit zählt zu deinem Fortschritt`)
};

const es_invite_page_step_3 = /** @type {(inputs: Invite_Page_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Su tiempo de concentración se suma a tu progreso`)
};

const fr_invite_page_step_3 = /** @type {(inputs: Invite_Page_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leur temps de concentration s’ajoute à votre progression`)
};

const it_invite_page_step_3 = /** @type {(inputs: Invite_Page_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il loro tempo di concentrazione si aggiunge ai tuoi progressi`)
};

const ja_invite_page_step_3 = /** @type {(inputs: Invite_Page_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相手の集中時間があなたの進捗に加算される`)
};

const ko_invite_page_step_3 = /** @type {(inputs: Invite_Page_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상대방의 집중 시간이 내 진행도에 더해져요`)
};

const pt_br_invite_page_step_3 = /** @type {(inputs: Invite_Page_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O tempo de foco delas aumenta seu progresso`)
};

const ru_invite_page_step_3 = /** @type {(inputs: Invite_Page_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Их время фокусировки добавляется к вашему прогрессу`)
};

const th_invite_page_step_3 = /** @type {(inputs: Invite_Page_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เวลาโฟกัสของพวกเขาจะเพิ่มความคืบหน้าของคุณ`)
};

const tr_invite_page_step_3 = /** @type {(inputs: Invite_Page_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onların odaklanma süresi ilerlemene eklenir`)
};

const zh_cn_invite_page_step_3 = /** @type {(inputs: Invite_Page_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对方的专注时间会累积你的进度`)
};

const zh_tw_invite_page_step_3 = /** @type {(inputs: Invite_Page_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`對方的專注時間會累積你的進度`)
};

/**
* | output |
* | --- |
* | "Their focus time adds to your progress" |
*
* @param {Invite_Page_Step_3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const invite_page_step_3 = /** @type {((inputs?: Invite_Page_Step_3Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Page_Step_3Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invite_page_step_3(inputs)
	if (locale === "ar") return ar_invite_page_step_3(inputs)
	if (locale === "de") return de_invite_page_step_3(inputs)
	if (locale === "es") return es_invite_page_step_3(inputs)
	if (locale === "fr") return fr_invite_page_step_3(inputs)
	if (locale === "it") return it_invite_page_step_3(inputs)
	if (locale === "ja") return ja_invite_page_step_3(inputs)
	if (locale === "ko") return ko_invite_page_step_3(inputs)
	if (locale === "pt_br") return pt_br_invite_page_step_3(inputs)
	if (locale === "ru") return ru_invite_page_step_3(inputs)
	if (locale === "th") return th_invite_page_step_3(inputs)
	if (locale === "tr") return tr_invite_page_step_3(inputs)
	if (locale === "zh_cn") return zh_cn_invite_page_step_3(inputs)
	return zh_tw_invite_page_step_3(inputs)
});